/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedTaxMinRequestDto } from '../../models/backend-patched-tax-min-request-dto';
import { BackendTaxMinDto } from '../../models/backend-tax-min-dto';

export interface ProjectTaxesTaxMinPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedTaxMinRequestDto;
}

export function projectTaxesTaxMinPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxMinPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxMinDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxMinPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxMinDto>;
    }),
  );
}

projectTaxesTaxMinPartialUpdate$FormData.PATH = '/api/project_taxes/tax_min/{id}/';
